"use client";

import { motion } from "framer-motion";
import { Star, Users, Handshake, TrendingUp, Globe } from "lucide-react";
import { Container } from "@/components/ui/container";
import { productStats } from "@/lib/constants";

const stats = [
  { icon: Star, value: "4.8", label: "avg rating" },
  { icon: Users, value: productStats.brandPartnerships.brands, label: "brands" },
  { icon: Handshake, value: productStats.brandPartnerships.partnerships, label: "partnerships" },
  { icon: TrendingUp, value: "$1.5M+", label: "AI revenue" },
];

const featuredFlags = ["🇺🇸", "🇬🇧", "🇩🇪", "🇫🇷", "🇦🇺", "🇯🇵", "🇸🇬", "🇨🇦"];

export function TrustBadge() {
  return (
    <section className="relative border-y border-line bg-page/80 py-6">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center gap-6"
        >
          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-5">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.08 }}
                  className="flex items-center gap-3 px-5 py-2.5 bg-panel rounded-2xl border border-line shadow-sm"
                >
                  <div className="p-2 bg-brand-green-soft rounded-xl">
                    <Icon className="w-6 h-6 text-brand-green" />
                  </div>
                  <div className="flex flex-col leading-none">
                    <span className="font-bold text-lg text-ink">{stat.value}</span>
                    <span className="text-xs text-muted">{stat.label}</span>
                  </div>
                </motion.div>
              );
            })}
          </div>

          {/* Countries */}
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-center"
          >
            <div className="flex flex-wrap items-center justify-center gap-1">
              {featuredFlags.map((flag, index) => (
                <motion.span
                  key={flag}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3, delay: 0.35 + index * 0.05 }}
                  className="flex items-center justify-center w-8 h-8 bg-panel rounded-full border border-line text-lg shadow-sm -ml-2 first:ml-0"
                >
                  {flag}
                </motion.span>
              ))}
              <span className="flex items-center justify-center w-8 h-8 bg-raised rounded-full border border-line text-xs font-semibold text-muted -ml-2">
                +17
              </span>
            </div>
            <div className="flex items-center gap-1.5 text-sm text-muted">
              <Globe className="w-4 h-4 text-brand-green" />
              <span>
                Trusted in <span className="font-semibold text-ink">{productStats.brandPartnerships.countries} countries</span>
              </span>
            </div>
          </motion.div>
        </motion.div>
      </Container>
    </section>
  );
}
